module.exports = __webpack_public_path__ + "01f43047/img/settings-ico.a214628d.svg";